import React from 'react'
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import homeImg from '../../assets/image/home.jpeg';

function Home() {
  return (
    <div className="homeSection">
    {/* <h3 className='sectionHeading'>Home</h3>
    <span className='headingAfterLine'></span> */}
    <div className='homeSectionWrap'>
        <div className='homeSectionContent'>
        <h5>Welcome to Parishrama Divyang Sports Academy!</h5>
            <p>
            At Parishrama, we believe in the transformative power of sports to inspire, empower, and uplift. Our academy is dedicated to creating an inclusive space where persons with Differently Abled persons (PWDs) can discover their potential, hone their skills, and achieve excellence. Through innovative programs, world-class coaching, and unwavering support, we are fostering a community of champions who redefine possibilities every day. Join us in our journey to make sports accessible and empowering for all.
            </p>
          
        </div>
        <div className='homeSectionImage'>
        <div className="homeImagWrap">
              <img src={homeImg} alt="about-sports" className='homeImg' />
          </div>
        </div>
    </div>
</div>
  )
}

export default Home
